import { DevelopmentHistoryFlatDTO } from "../domain/models/dto/DevelopmentHistoryDTO";
import { IDevelopmentHistoryFlat } from "../domain/models/DevelopmentHistory";
import { DevelopmentHistoryFlatModel } from "../models/DevelopmentHistoryFlatModel";
import { FileMapper } from "./FileMapper";
import { SimpleMapper } from "./SimpleMapper";

export class DevelopmentHistoryFlatMapper extends SimpleMapper<IDevelopmentHistoryFlat, DevelopmentHistoryFlatDTO> {
    protected toDTOFields: string[] = [
        "id",
        "title",
        "description",
        "stageDateTime",
        "imageUrl",
        "languageCode",
        "files",
    ];

    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "createdAt",
        "updatedAt",
        "creatorId",
    ];

    protected entityConstructor = DevelopmentHistoryFlatModel;

    private fileMapper = new FileMapper();

    fromDTO(dto: DevelopmentHistoryFlatDTO): IDevelopmentHistoryFlat {
        if (!dto) return null;

        const baseModel = super.fromDTO(dto);
        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];

        return baseModel;
    }

    toDTO(model: IDevelopmentHistoryFlat): DevelopmentHistoryFlatDTO {
        if (!model) return null;

        const baseDto = super.toDTO(model);
        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }
}
